export default {
	emailRegex: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
	phoneRegex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
	numberRegex: /^[0-9]*$/,
	exceptNumberRegex: /^([^0-9]*)$/,
	spaceRegex: /^\s+$/g,
	specialCharRegex: /^[a-zA-Z\d\-_.,\s]+$/,
	urlRegex: /^https?:\/\/+[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
	stripePubKeyBeta: 'pk_test_On7F5lbpijoNlLvtVGSQsFnH',
	stripePubKeyLive: 'pk_live_IdHTcBcTnKOG0KMhWIdDQelw',
	paypalSecKeyBeta: 'Ae6rKJN84Lc4xUebNbNsKAFppIpQqVZS-BIFfItfzgL3668bHqgj7j2TQIL0KBT4u8w3n0370HKGgYE7',
	paypalSecKeyLive: 'Ae6rKJN84Lc4xUebNbNsKAFppIpQqVZS-BIFfItfzgL3668bHqgj7j2TQIL0KBT4u8w3n0370HKGgYE7',
	// New: Disallowed email domains
	disallowedDomains: [
		// Google
		"gmail.com",

		// Yahoo group
		"yahoo.com",
		"ymail.com",
		"rocketmail.com",

		// Microsoft group
		"hotmail.com",
		"outlook.com",
		"live.com",
		"msn.com",

		// Apple
		"icloud.com",
		"me.com",
		"mac.com",

		// Secure/personal free email providers
		"protonmail.com",
		"pm.me",
		"tutanota.com",
		"fastmail.com",
		"gmx.com",
		"zoho.com",
		"aol.com",
		"mail.com",
		"yandex.com",
		"yandex.ru",

		// Disposable / temporary email providers

		// Mailinator family
		"mailinator.com",
		"tradermail.info",
		"mailinater.com",
		"suremail.info",
		"spamherelots.com",

		// Temp-Mail family
		"tempmail.com",
		"temp-mail.org",
		"tempmail.net",
		"tempmail365.com",
		"tmpmail.net",
		"tmpmail.org",

		// Guerrilla Mail family
		"guerrillamail.com",
		"guerrillamail.info",
		"guerrillamail.biz",
		"guerrillamail.de",
		"guerrillamail.net",
		"guerrillamail.org",
		"grr.la",
		"spam4.me",

		// 10MinuteMail / related
		"10minutemail.com",
		"10minutemail.net",
		"10minutemail.org",
		"10minemail.com",
		"minutemailbox.com",

		// YOPmail
		"yopmail.com",
		"yopmail.fr",
		"cool.fr.nf",
		"jetable.fr.nf",
		"nospam.ze.tc",
		"nomail.xl.cx",
		"mega.zik.dj",
		"speed.1s.fr",
		"courriel.fr.nf",
		"moncourrier.fr.nf",
		"monemail.fr.nf",
		"monmail.fr.nf",

		// TrashMail
		"trashmail.com",
		"trashmail.at",
		"trashmail.io",
		"trashmail.me",
		"trashmail.net",
		"trashmail.org",
		"trashmail.xyz",

		// Maildrop
		"maildrop.cc",

		// Throwaway / Burner
		"throwawaymail.com",
		"throwam.com",
		"burner.kiwi",

		// DispoMail / SpamBox / misc
		"dispomail.xyz",
		"spambox.xyz",
		"spamgourmet.com",
		"spamgourmet.net",
		"spamgourmet.org",
		"dispostable.com",
		"fakeinbox.com",
		"sharklasers.com",
		"getnada.com",
		"moakt.com",

		// Misc well-known disposables
		"mailnull.com",
		"spamcowboy.com",
		"spamcowboy.net",
		"spamcowboy.org",
		"wegwerfmail.de",
		"wegwerfmail.net",
		"wegwerfmail.org",
		"sofort-mail.de",
		"spam.la",
		"bobmail.info",
		"mailme.lv",
		"filzmail.com",
		"einrot.com",

		// Common QA/test domains
		"example.com",
		"test.com",
		"testing.com",
		"email.com",

		// 🔻 Regional Free Providers (Asia, Europe, etc.)
		"qq.com",             // China - Tencent Mail
		"163.com",            // China - NetEase Mail
		"126.com",            // China - NetEase Mail
		"sina.com",           // China - Sina Mail
		"naver.com",          // Korea - Naver
		"daum.net",           // Korea - Daum
		"rediffmail.com",     // India - Rediff
		"mail.ru",            // Russia - Mail.ru
		"bk.ru",              // Russia - Mail.ru
		"list.ru",            // Russia - Mail.ru
		"inbox.ru",           // Russia - Mail.ru
		"web.de",             // Germany
		"freenet.de",         // Germany
		"libero.it",          // Italy
		"seznam.cz",          // Czech
		"centrum.cz",         // Czech
		"wp.pl",              // Poland
		"onet.pl",            // Poland
		"abv.bg",             // Bulgaria
		"mail.bg",             // Bulgaria

		"bitonic.com",
		"bitonic.co",
		"152mail.com",
		"152mail.com.cn",

		// Student email domains
		"student.tp.edu.sg",
		"student.esaunggul.ac.id"
	],
}
